/** @format */

/**
 * External dependencies
 */
import { get } from 'lodash';
import { select } from '@wordpress/data';

/**
 * Internal dependencies
 */
import { serializeQueryArgs } from '../utils';
import { ERROR } from '../constants';

/**
 * Returns availability for a specific query.
 *
 * @param {Object} state Current state
 * @param {Object} query Availability query parameters
 * @return {Array} Availability
 */
function getAvailability( state, query = {} ) {
	return get( state, [ 'availability', serializeQueryArgs( query ), 'records' ], [] );
}

/**
 * Returns the current page number for availability pagination.
 *
 * @param {Object} state Current state
 * @param {Object} query Availability query parameters
 * @return {Array} Availability
 */
function getPage( state, query ) {
	return get( state, [ 'availability', serializeQueryArgs( query ), 'page' ], 1 );
}

/**
 * Returns the number of total (not pagianted) availability records for the current query.
 *
 * @param {Object} state Current state
 * @param {Object} query Availability query parameters
 * @return {Int} Amount of total availability records
 */
function getAvailabilityTotalRecords( state, query = {} ) {
	return get( state, [ 'availability', serializeQueryArgs( query ), 'count' ], [] );
}

export default {
	getAvailability,
	getPage,
	getAvailabilityTotalRecords,
	/**
	 * Returns true if a query is pending.
	 *
	 * @param  {Object} state   Current state
	 * @return {Boolean}        True if the `getAvailability` request is pending, false otherwise
	 */
	isGetAvailabilityRequesting( state, ...args ) {
		return select( 'core/data' ).isResolving( 'woocommerce-bookings-availability', 'getAvailability', args );
	},

	/**
	 * Returns true if a get availability request has returned an error.
	 *
	 * @param  {Object} state     Current state
	 * @param  {Object} query     Query parameters
	 * @return {Boolean}          True if the `getAvailability` request has failed, false otherwise
	 */
	isGetAvailabilityError( state, query ) {
		return ERROR === getAvailability( state, query );
	},
};
